import React from "react";
import styled from "styled-components";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { DetailPropertyForm } from "../form/DetailPropertyForm";
import { PropertyFormData } from "../form/PropertyForm";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    property?: PropertyFormData | null;
};

export const DetailPropertyModal: React.FC<Props> = ({ isOpen, onClose, property }) => {
    return (
        <ModalTemplate
            isOpen={isOpen}
            title="Property Details"
            onClose={onClose}
            maxWidth="95vw"
        >
            <ResponsiveWrapper>
                {property ? <DetailPropertyForm property={property} /> : <div>No property selected.</div>}
            </ResponsiveWrapper>
        </ModalTemplate>
    );
};

const ResponsiveWrapper = styled.div`
  @media (max-width: 768px) {
    padding: 0 8px;
  }
  
  @media (max-width: 480px) {
    padding: 0 4px;
  }
`;
